import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { referralGet } from '@collections/referral/referral.action';
import { Store } from '@ngrx/store';
import { CandidateAdapter } from '@shared';

import { CandidatesConfig, CandidatesPrivileges } from '../../../../candidates.abstract.config';

@Component({
  selector: 'mojo-candidate-details-card',
  templateUrl: './candidate-details-card.component.html',
  styleUrls: ['./candidate-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateDetailsCardComponent implements OnInit {
  @Input() candidate: CandidateAdapter;

  privileges: CandidatesPrivileges = this.candidatesConfig.privileges;
  colSize = 12;

  constructor(private candidatesConfig: CandidatesConfig, private store: Store<{}>) {}

  ngOnInit(): void {
    if (this.candidate.referredId) {
      this.store.dispatch(referralGet({ referralId: this.candidate.referredId }));
    }
  }
}
